<template>
    <div class="StackedCarousel">
        <div class="StackedCarousel__wrapper container relative">
            <div
                class="StackedCarousel__container"
            >
                <flickity
                    ref="flickity"
                    :options="flickityOptions"
                >
                    <div
                        v-for="(image, index) in images"
                        :key="index + image.srcset"
                        :data-index="index"
                        :class="classes(index)"
                        class="StackedCarousel__image"
                    >
                        <BaseImage
                            :placeholder="image.placeholder"
                            :srcset="image.srcset"
                            :ratio="image.ratio"
                            :sizes="imageSizes"
                        />
                    </div>
                </flickity>
                <div
                    class="StackedCarousel__content"
                >
                    <div
                        v-for="(content, index) in contents"
                        :key="index"
                        :data-slide="index"
                        :class="states[index]"
                        class="StackedCarousel__slide wysiwyg"
                    >
                        <BaseHeading
                            :heading="content.heading"
                            :preheading="content.preheading"
                            tag="h2"
                        />
                        <BaseText
                            class="StackedCarousel__text"
                            :text="content.text"
                        />
                        <BaseButton
                            :href="content.url"
                            modifier="medium"
                        >
                            {{ content.buttonText }}
                        </BaseButton>
                    </div>
                    <ul
                        class="StackedCarousel__nav"
                    >
                        <ProgressiveCircle
                            v-for="n in images.length"
                            :key="n"
                            :index="n - 1"
                            :active-slide="activeSlide"
                            @setActive="setActive"
                        />
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Flickity from './BaseCarousel.vue'
import ProgressiveCircle from './ProgressiveCircle.vue'

export default {
    name: 'HomeStackedCarousel',
    components: {
        Flickity,
        ProgressiveCircle
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                imagesLoaded: true,
                autoPlay: 6000,
                selectedAttraction: 0.0005,
                friction: 0.8
            },
            activeSlide: 0,
            states: [
                'is-active',
                'is-next',
                'is-prev'
            ],
            imageSizes: "(max-width: 767px) 100vw, (min-width: 768px) and (max-width: 1270px) 50vw, 635px"
        }
    },
    computed: {
        contents() {
            return this.$attrs.items.reduce((total, curr) => {
                total.push({
                    heading: curr.heading,
                    preheading: curr.preheading,
                    buttonText: curr.buttonText,
                    url: curr.customUrl || curr.url,
                    text: curr.text,
                });
                return total;
            }, [])
        },
        images() {
            return this.$attrs.items.reduce((total, curr) => {
                total.push({
                    placeholder: curr.placeholder,
                    srcset: curr.image,
                    ratio: curr.ratio,
                });
                return total;
            }, [])
        }
    },
    mounted() {
        const carousel = document.querySelector('.StackedCarousel')
        const flkty = this.$refs.flickity.data(carousel)

        flkty.on('change', () => {
            this.addPrevNextClasses(carousel, flkty)
            this.selectActive(carousel, flkty)
        });
    },
    methods: {
        classes(index) {
            return index === 1 ? 'is-next' : index === 2 ? 'is-prev' : null
        },
        next() {
            this.$refs.flickity.next();
        },

        previous() {
            this.$refs.flickity.previous();
        },

        setActive(index) {
            this.$refs.flickity.select(index);
        },

        selectActive(carousel, flkty) {
            const contents = carousel.querySelectorAll('[data-slide]')
            for (var i = 0; i < contents.length; i++) {
                const content = contents[i]
                content.classList.remove('is-active')
                if (Number(content.dataset.slide) === flkty.selectedIndex) {
                    content.classList.add('is-active')
                }
            }

            this.activeSlide = flkty.selectedIndex;
        },
        addPrevNextClasses(carousel, flkty) {
            const slides = carousel.querySelectorAll('.StackedCarousel__image');

            for (var i = 0; i < slides.length; i++) {
                const slide = slides[i]
                slide.classList.remove('is-next', 'is-prev')
            }

            const slide0 = carousel.querySelector('*[data-index="0"]');
            const slide1 = carousel.querySelector('*[data-index="1"]');
            const slide2 = carousel.querySelector('*[data-index="2"]');

            if (flkty.selectedIndex === 1) {
                slide2.classList.add('is-next')
                slide0.classList.add('is-prev')
            }
            if (flkty.selectedIndex === 0) {
                slide1.classList.add('is-next')
                slide2.classList.add('is-prev')
            }
            if (flkty.selectedIndex === 2) {
                slide0.classList.add('is-next')
                slide1.classList.add('is-prev')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .StackedCarousel {
        ::v-deep .flickity-enabled {
            height: 100%;
            width: 100%;

            @include media-query(lap) {
                width: 70%;
            }
            @include media-query(desk) {
                width: 75%;
            }
        }

        ::v-deep .BaseImage {
            background: transparent;
        }

        ::v-deep .flickity-viewport {
            overflow: visible;
            max-width: 550px;

            @include media-query(lap-and-up) {
                position: absolute;
                width: 110%;
                z-index: 1;
                margin-top: -140px;
                max-width: initial;
            }

            @include media-query(desk) {
                margin-top: -200px;
            }
        }

        ::v-deep .flickity-slider {
            position: relative;
            margin-left: auto;
            margin-right: auto;
            height: auto;
            -ms-touch-action: pan-x;
            touch-action: pan-x;
            // -webkit-perspective: 1200px;
            // perspective: 1200px;
            margin-left: - getSpacing('large');
            transform: none!important;
            left: 0!important;

            @include media-query(palm) {
                margin-left: - getSpacing('medium');
                margin-right: - getSpacing('medium');
            }
            @include media-query(lap) {
                height: 400px;
                width: 100%;
            }

            @include media-query(desk) {
                height: 540px;
                width: 100%;
            }
        }
    }
</style>
<style lang="scss">

.StackedCarousel {
    background: $border-color;

    @include media-query(palm) {
        background: getColor('white');
        padding-bottom: getSpacing('spacer');
        overflow: hidden;
    }

    @include media-query(palm) {
        margin-top: - getSpacing('small');
    }

    .viewport {
        overflow: visible;
        max-width: 550px;

        @include media-query(lap-and-up) {
            position: absolute;
            width: 110%;
            z-index: 1;
            margin-top: -140px;
            max-width: initial;
        }

        @include media-query(desk) {
            margin-top: -200px;
        }
    }

    .enabled {
        position: relative;
        height: 100%;
        width: 100%;

        @include media-query(lap) {
            width: 70%;
        }
        @include media-query(desk) {
            width: 75%;
        }
    }

    .slider {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        height: auto;
        -ms-touch-action: pan-x;
        touch-action: pan-x;
        // -webkit-perspective: 1200px;
        // perspective: 1200px;
        margin-left: - getSpacing('large');
        transform: none!important;
        left: 0!important;

        @include media-query(palm) {
            margin-left: - getSpacing('medium');
            margin-right: - getSpacing('medium');
        }
        @include media-query(lap) {
            height: 400px;
            width: 100%;
        }

        @include media-query(desk) {
            height: 540px;
            width: 100%;
        }
    }
}

    .StackedCarousel__wrapper {
        padding-top: 48px;
        padding-bottom: 88px;
        z-index: 2;

        @include media-query(palm) {
            padding-top: 128px;
            padding-bottom: 0;
        }
    }

    .StackedCarousel__container {
        @include media-query(lap-and-up) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: auto;
            // FIX: Avoiding z-index issues until wider stacking problem is resolved
            transform: translate3d(0,0,0);
        }
    }

    .StackedCarousel__content {
        position: relative;
        display: block;
        margin: 0 auto;
        //padding: getSpacing('base') 0;

        @include media-query(lap-and-up) {
            display: flex;
            align-items: center;
            width: 50%;
            height: 400px;
        }

        @include media-query(desk) {
            height: 600px;
        }
    }

    .StackedCarousel__slide {
        display: none;

        //transition: opacity 1200ms cubic-bezier(0.23, 1, 0.32, 1);

        @include media-query(smart) {
            padding-top: 0;
        }
        @include media-query(palm) {
            padding-top: getSpacing('large');
        }

        &.is-active {
            display: block;
        }

        .BaseButton {
            display: inline-block;
            margin-top: 1.5rem;
            @include media-query(desk) {
                margin-top: 2rem;
            }
        }

        @include media-query(lap-and-up) {
            display: block;
            visibility: hidden;
            position: absolute;
            right: 0;
            left: 0;
            top: 50%;
            bottom: 0;
            margin: 0 auto;
            transform: translateY(-50%);
            opacity: 0;
            transition: visibility 0s, opacity 0.245s ease-out;

            &.is-active {
                opacity: 1;
                visibility: visible;
            }
        }
    }

    .StackedCarousel .BaseText {
        margin-top: -1rem!important;
    }


    .StackedCarousel__image {
        position: absolute;
        top: 0;
        left: 0!important;
        transform-style: preserve-3d;
        transition-property: all;
        will-change: transform;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
        width: 95%;
        outline: 1px solid transparent;

        @include media-query(lap) {
            width: 75%;
        }

        @include media-query(desk) {
            width: 75%;
        }

        img {
            width: 100%;
        }

        &.is-selected {
            z-index: 4 !important;
            transform: translate(-10px, -30px) translateZ(1px) rotate(-5deg)!important;

            @include media-query(lap-and-up) {
                transform: translate(0px, -40px) translateZ(1px) rotate(-5deg)!important;
            }
        }

        &.is-prev {
            z-index: 2;
            transform: translate(90px, 20px) translateZ(1px) rotate(5deg) !important;
            box-shadow: 0 10px 60px 10px rgba(0,0,0,0.4);

            @include media-query(lap-and-up) {
                transform: translate(100px, 30px) translateZ(1px) rotate(5deg) !important;
            }
        }

        &.is-next {
            z-index: 3;
            transform: translate(50px, -5px) translateZ(1px) !important;

            @include media-query(lap-and-up) {
                transform: translate(60px, -10px) translateZ(1px) !important;
            }
        }
    }

    .StackedCarousel__nav {
        display:block;
        margin-top: getSpacing('medium');

        @include media-query(lap-and-up) {
            position: absolute;
            bottom: getSpacing('medium');
            right: 0;
        }
    }
</style>
